<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<ng-container [formGroup]="group">
  <div [formGroupName]="model.id" [id]="id" [attr.data-name]="model.name" [ngClass]="getClass('element', 'control')">
    @for (_model of model.group; track _model) {
      <dynamic-form-control
        [group]="$any(control)"
        [hidden]="_model.hidden"
        [layout]="formLayout"
        [model]="_model"
        [hostClass]="[getClass('element', 'children'), getClass('grid', 'children')]"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
        (metaDataSelectedEvent)="metaDataSelected($event)"
      ></dynamic-form-control>
    }
  </div>
</ng-container>
